$(function () {
    if ($('form#AvailabilityDashboardForm').length > 0) {


        function UpdateChartSize() {

            var ratio = screen.width > screen.height ? 2 : 1;

            var chartCanvases = $("canvas");

            chartCanvases.each(function () {
                var id = $(this).attr("id")

                var chart = Chart.getChart(id);

                if (chart) {
                    var parent = $(this).parent();

                    if (parent.width() > 0) {
                        parent.height(parent.width() / ratio);
                    }
                }
            });
        }

        $(window).resize(function () {
            UpdateChartSize();
        }).resize();

        $(window).on("orientationchange", function () {
            UpdateChartSize();
        });

        var chartColours = ['#0069aa', '#ffcd00', '#808080', '#772432', '#000000']

        const trendsFooter = (tooltipItems) => {
            var formatter = new Intl.NumberFormat(jsLangCode, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            var txt;
            tooltipItems.forEach(function (tooltipItem) {
                txt = tooltipItem.label;
            });

            if (jsLangCode == 'fr-CA') {
                jsInfantEnrolment = jsInfantEnrolment.replace('.', ',');
                jsInfantAvailable = jsInfantAvailable.replace('.', ',');

                jsPreschoolEnrolment = jsPreschoolEnrolment.replace('.', ',');
                jsPreschoolAvailable = jsPreschoolAvailable.replace('.', ',');

                jsSchoolAgetEnrolment = jsSchoolAgetEnrolment.replace('.', ',');
                jsSchoolAgeAvailable = jsSchoolAgeAvailable.replace('.', ',');
            }
            

            if (txt == jsInfant) {
                //return [jsEnrolment + ": " + jsInfantEnrolment, jsAvailable + ": " + jsInfantAvailable];
                return [jsEnrolment + ": " + jsInfantEnrolment];

            }
            if (txt == jsPreschool) {
                //return [jsEnrolment + ": " + jsPreschoolEnrolment, jsAvailable + ": " + jsPreschoolAvailable];
                return [jsEnrolment + ": " + jsPreschoolEnrolment];
            }
            if (txt == jsSchoolAge) {
                //return [jsEnrolment + ": " + jsSchoolAgetEnrolment, jsAvailable + ": " + jsSchoolAgeAvailable];
                return [jsEnrolment + ": " + jsSchoolAgetEnrolment];
            }
        };

        const trendsCanvas = document.getElementById('trendsChart');
        const trendsCanvasNotHme = document.getElementById('trendsChartNotHome');

        const bgPlugin = {
            id: 'customCanvasBackgroundColor',
            beforeDraw: (chart, args, options) => {
                const { ctx } = chart;
                ctx.save();
                ctx.globalCompositeOperation = 'destination-over';
                ctx.fillStyle = options.color || '#99ffff';
                ctx.fillRect(0, 0, chart.width, chart.height);
                ctx.restore();
            }
        };

        new Chart(trendsCanvas, {
            type: 'bar',
            data: {
                labels: [jsInfant, jsPreschool, jsSchoolAge],
                datasets: [
                    {
                        label: jsEnrolment,
                        data: [jsInfantEnrolment, jsPreschoolEnrolment, jsSchoolAgetEnrolment],
                        backgroundColor: chartColours[0]
                    }
                    //}, {
                    //    label: jsAvailable,
                    //    data: [jsInfantAvailable, jsPreschoolAvailable, jsSchoolAgeAvailable],
                    //    backgroundColor: chartColours[1]
                    //}
                ]
            },
            options: {
                onresize: function (a, b) { console.log(a); console.log(b); },
                maintainAspectRatio: false,
                animation: false,
                locale: jsLangCode,
                plugins: {
                    legend: { position: 'bottom' },
                    title: {
                        display: true,
                        text: jsEnrolmentAvailability,
                        color: "#000000",
                        font: {
                            size: 14
                        }
                    },
                    subtitle: {
                        display: true,
                        text: jsSubtitleText
                    },
                    tooltip: {
                        callbacks: {
                            label: () => null,
                            footer: trendsFooter
                        },
                        footerFont: {
                            weight: "normal"
                        }
                    },
                    customCanvasBackgroundColor: {
                        color: 'white'
                    }
                },
                responsive: true,
                scales: {
                    x: {
                        stacked: true,
                    },
                    y: {
                        stacked: true,
                        suggestedMax: jsSuggestedMax,
                        ticks: {
                            stepSize: 0.5
                            }
                    }
                }
            },
            plugins: [bgPlugin]
        });


        const trendsFooterNotHome = (tooltipItems) => {
            var formatter = new Intl.NumberFormat(jsLangCode, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            var txt;
            tooltipItems.forEach(function (tooltipItem) {
                txt = tooltipItem.label;
            });

            if (jsLangCode == 'fr-CA') {
                jsInfantEnrolment = jsInfantEnrolment.replace('.', ',');
                jsInfantAvailable = jsInfantAvailable.replace('.', ',');
                jsInfantRemainingSpaces = jsInfantRemainingSpaces.replace('.', ',');

                jsPreschoolEnrolment = jsPreschoolEnrolment.replace('.', ',');
                jsPreschoolAvailable = jsPreschoolAvailable.replace('.', ',');
                jsPreschoolRemainingSpaces = jsPreschoolRemainingSpaces.replace('.', ',');

                jsSchoolAgetEnrolment = jsSchoolAgetEnrolment.replace('.', ',');
                jsSchoolAgeAvailable = jsSchoolAgeAvailable.replace('.', ',');
                jsSchoolageRemainingSpaces = jsSchoolageRemainingSpaces.replace('.', ',');
            }


            if (txt == jsInfant) {
                return [jsEnrolment + ": " + jsInfantEnrolment, jsAvailable + ": " + jsInfantAvailable, jsRemaining + ": " + jsInfantRemainingSpaces];

            }
            if (txt == jsPreschool) {
                return [jsEnrolment + ": " + jsPreschoolEnrolment, jsAvailable + ": " + jsPreschoolAvailable, jsRemaining + ": " + jsPreschoolRemainingSpaces];
            }
            if (txt == jsSchoolAge) {
                return [jsEnrolment + ": " + jsSchoolAgetEnrolment, jsAvailable + ": " + jsSchoolAgeAvailable, jsRemaining + ": " + jsSchoolageRemainingSpaces];
            }
        };

        //Canvas not home
        new Chart(trendsCanvasNotHme, {
            type: 'bar',
            data: {
                labels: [jsInfant, jsPreschool, jsSchoolAge],
                datasets: [
                    {
                        label: jsEnrolment,
                        data: [jsInfantEnrolment, jsPreschoolEnrolment, jsSchoolAgetEnrolment],
                        backgroundColor: chartColours[0]
                    }, {
                        label: jsAvailable,
                        data: [jsInfantAvailable, jsPreschoolAvailable, jsSchoolAgeAvailable],
                        backgroundColor: chartColours[1]
                    }, {
                        label: jsRemaining,
                        data: [jsInfantRemainingSpaces, jsPreschoolRemainingSpaces, jsSchoolageRemainingSpaces],
                        backgroundColor: chartColours[2]
                        }
                ]
            },
            options: {
                onresize: function (a, b) { console.log(a); console.log(b); },
                maintainAspectRatio: false,
                animation: false,
                locale: jsLangCode,
                plugins: {
                    legend: { position: 'bottom' },
                    title: {
                        display: true,
                        text: jsEnrolmentAvailability,
                        color: "#000000",
                        font: {
                            size: 14
                        }
                    },
                    subtitle: {
                        display: true,
                        text: jsSubtitleText
                        },
                    tooltip: {
                        callbacks: {
                            label: () => null,
                            footer: trendsFooterNotHome
                        },
                        footerFont: {
                            weight: "normal"
                        }
                    },
                    customCanvasBackgroundColor: {
                        color: 'white'
                    }
                },
                responsive: true,
                scales: {
                    x: {
                        stacked: true,
                    },
                    y: {
                        stacked: true,
                        suggestedMax: jsSuggestedMax,
                        ticks: {
                            stepSize: 0.5
                        }
                    }
                }
            },
            plugins: [bgPlugin]
        });

        $("#ExportChart").click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            // find the canvas element currently shown
            var chartElement = $(".chartavail").find("canvas").first();

            if (chartElement) {
                // if we find the element, we can use chart.js to get the chart object...
                var id = chartElement.attr("id")

                var chart = Chart.getChart(id);

                var title = chart.options.plugins.title.text;
                var date = new Date().toISOString().substring(0, 10);

                // .. and export it to an image file.
                var a = document.createElement('a');
                a.href = chart.toBase64Image();
                a.download = title + "_" + date + ".png";

                a.click();

                a.remove();
            }

            return false;
        });
    } // if ($('form#StatementSummaryForm').length > 0) {
}); // $(function () {